export default __webpack_public_path__ + "static/media/walking.6e3eab42.svg";